module.exports = __webpack_public_path__ + "static/media/bar-inset.554cbf11.png";